import { API } from "aws-amplify";

async function getSnapshots(siteId: string): Promise<ImageDownload[]> {
  try {
    const path: string = `/annotated-images/${siteId}`;

    const data = await API.get(
      'api-service',
      path,
      {}
    )

    if (data.data) {
      return data.data as ImageDownload[];
    }
    
    return [];
  } catch (error) {
    throw error;
  }
}

export default getSnapshots;
